export function isNullOrEmpty(str){
    if(!str || str.trim === ''){
        return true
    }
    else{
        return false
    }
}